var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking-layout"},[_c('TrackingBreadcrumb'),_c('TrackingForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }